import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { API } from "@/lib/constants";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("zkn_token")) navigate("/admin/panel");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("zkn_token", data.token);
      navigate("/admin/panel");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Logowanie nie powiodło się.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-beige/70 hover:text-gold transition-colors mb-8 font-manrope text-sm" data-testid="admin-back-home">
          <ArrowLeft className="h-4 w-4" /> Strona główna
        </a>
        <div className="bg-beige rounded-2xl p-8 md:p-10 shadow-clay-lg">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-gold mb-5">
            <Lock className="h-6 w-6" strokeWidth={1.75} />
          </span>
          <h1 className="font-outfit text-2xl font-medium text-ink">Panel administratora</h1>
          <p className="mt-2 font-manrope text-sm text-ink-soft">Zaloguj się, aby zobaczyć zapisy do newslettera.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block font-outfit text-sm text-ink mb-1.5">E-mail</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-surface border border-line px-4 py-3 rounded-2xl font-manrope text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="block font-outfit text-sm text-ink mb-1.5">Hasło</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-surface border border-line px-4 py-3 rounded-2xl font-manrope text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
                data-testid="admin-password-input"
              />
            </div>
            {error && <p className="font-manrope text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-forest text-beige px-8 py-3.5 rounded-2xl font-outfit tracking-wide hover:bg-forest-hover shadow-clay hover:shadow-clay-lg transition-all disabled:opacity-60"
              data-testid="admin-login-button"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Zaloguj się"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
